import { IAuthorizationService, IEventService } from '@price-for-profit/micro-services';
import { createContext, PropsWithChildren, useContext } from 'react';
import { IContractService } from 'shared/services/contract-service';
import { ICustomerService } from 'shared/services/customer-service';
import { IDraftContractService } from 'shared/services/draft-contract-service';
import { IDraftCustomerNameChangeService } from 'shared/services/draft-name-change-service';
import { IProductService } from 'shared/services/product-service';
import { IQuoteService } from 'shared/services/quote-service';
import { AppConfig } from 'shared/types';

export interface ServiceContext {
  appConfig: AppConfig;
  customerService: ICustomerService;
  productService: IProductService;
  quoteService: IQuoteService;
  contractService: IContractService;
  draftContractService: IDraftContractService;
  draftNameChangeService: IDraftCustomerNameChangeService;
  eventService: IEventService;
  authService: IAuthorizationService;
}
type ServiceProviderProps = {
  context: ServiceContext;
};

const serviceContext = createContext<ServiceContext>({} as ServiceContext);

export function ProvideService({ children, context }: PropsWithChildren<ServiceProviderProps>) {
  return <serviceContext.Provider value={context}>{children}</serviceContext.Provider>;
}

export function useService() {
  return useContext(serviceContext);
}
